import { cacheFunc } from '@tencent/wphk-base-utils';
import { request } from '@tencent/ppd-base-libs';
import { ActCycleConfig } from '../types';

// import axios from 'axios';

// request.init(axios);

/** 灰度配置链接前缀，例如业务是 hengsheng-stamp, 则完整链接是 //st.moneydata.hk/res/cc/actcycle/hengsheng-stamp.json  */
const CONFIG_URL_PREFIX = 'https://st.moneydata.hk/res/cc/actcycle';

/** 获取配置的请求方法 */
const requestConfig = (business: string): Promise<ActCycleConfig[]> =>
  request.loadVtools(`${CONFIG_URL_PREFIX}/${business}.json`);

const cacheRequestConfig = cacheFunc(requestConfig);

/** 拉取业务配置 */
export async function getConf(params: { business: string }): Promise<ActCycleConfig | undefined> {
  const { business } = params;
  const config = await cacheRequestConfig(business);
  return (config || []).find((conf: ActCycleConfig) => conf.business === business);
}
